import { baseURL, secretKey } from "./config";

// Yeni ozellikler (oda, PK, oyun, ekonomi) icin admin istemcisi.
const request = async (path, { method = "GET", body, form, base = "adminPanel/" } = {}) => {
  const headers = { key: secretKey, Authorization: sessionStorage.getItem("token") || "" };
  if (!form) headers["Content-Type"] = "application/json";
  const res = await fetch(`${baseURL}${base}${path}`, {
    method,
    headers,
    body: form ? form : body ? JSON.stringify(body) : undefined,
  });
  if (res.status === 401) {
    sessionStorage.clear();
    window.location.href = "/";
    return { status: false, message: "Oturum süresi doldu." };
  }
  try {
    return await res.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};

const qs = (o = {}) =>
  Object.entries(o)
    .filter(([, v]) => v !== undefined && v !== "")
    .map(([k, v]) => `${k}=${encodeURIComponent(v)}`)
    .join("&");

const panelApi = {
  makeHost: (userId) => request("admin/makeHost", { method: "POST", body: { userId }, base: "user/" }),
  removeHost: (userId) => request("admin/removeHost", { method: "POST", body: { userId }, base: "user/" }),
  makeAgency: (userId, name) => request("admin/makeAgency", { method: "POST", body: { userId, name }, base: "user/" }),
  overview: () => request("overview"),
  roomAnnounce: (text, region, live) => request("roomAnnounce", { method: "POST", body: { text, region, live } }),
  gifGrant: (userId, days) => request("gifAvatar", { method: "POST", body: { userId, days } }),
  pulse: () => request("pulse"),
  foodStats: () => request("foodStats"),
  fruitayvoStats: () => request("fruitayvoStats"),
  gamePlayers: (game, days) => request(`gamePlayers?game=${game}&days=${days}`),
  fruitStats: () => request("fruitStats"),
  yummyStats: () => request("yummyStats"),
  rocketStats: () => request("rocketStats"),
  flyStats: () => request("flyStats"),
  rouletteStats: () => request("rouletteStats"),
  oceanStats: () => request("oceanStats"),
  slotsStats: () => request("slotsStats"),
  olymposStats: () => request("olymposStats"),
  sekerStats: () => request("sekerStats"),
  hotbellStats: () => request("hotbellStats"),
  kleoStats: () => request("kleoStats"),
  mrrichStats: () => request("mrrichStats"),
  bigbassStats: () => request("bigbassStats"),
  miamiStats: () => request("miamiStats"),
  ortakHavuzStats: () => request("ortakHavuzStats"),
  gemsStats: () => request("gemsStats"),
  racingStats: () => request("racingStats"),
  dragonStats: () => request("dragonStats"),
  luckyEngine: () => request("luckyEngine"),
  saveLuckyEngine: (patch) => request("luckyEngine", { method: "POST", body: { patch } }),
  duplicates: (by) => request(by === "ip" ? "duplicates?by=ip&all=1" : "duplicates?all=1"),
  dupHistory: () => request("duplicates/history"),
  incSohbetler: (q) => request(`inceleme/sohbetler?${qs({ q })}`),
  incMesajlar: (topicId, before) => request(`inceleme/mesajlar?${qs({ topicId, before })}`),
  incAramalar: (q, days) => request(`inceleme/aramalar?${qs({ q, days })}`),
  incIzle: (id) => request(`inceleme/izle?${qs({ id })}`),
  incBanGecmisi: (q) => request(`inceleme/banGecmisi?${qs({ q })}`),
  incTransfer: (host, agency) => request("inceleme/transfer", { method: "POST", body: { host, agency } }),
  incDinle: (id) => request(`inceleme/dinle?${qs({ id })}`),
  incKanit: (id) => request(`inceleme/kanit?${qs({ id })}`),
  karZarar: (days) => request(`karZarar?${qs({ days })}`),
  uyarilar: (hepsi, tur) => request(`uyarilar?${qs({ hepsi: hepsi ? 1 : "", tur })}`),
  uyariOkundu: (body) => request("uyariOkundu", { method: "POST", body }),
  iadeler: () => request("iadeler"),
  iadeTara: () => request("iadeTara", { method: "POST" }),
  rolYetki: () => request("rolYetki"),
  rolYetkiKaydet: (v) => request("rolYetki", { method: "POST", body: { v } }),
  dupUndo: (id) => request("duplicates/undo", { method: "POST", body: { id } }),
  coinFlow: (q, days) => request(`coinFlow?${qs({ q, days })}`),
  storePurchases: (o) => request(`storePurchases?${qs(o)}`),
  denemeCoin: (body) => request("denemeCoin", { method: "POST", body }),
  forceLogout: () => request("forceLogout", { method: "POST" }),
  mergeAccounts: (keepId, mergeId) => request("duplicates/merge", { method: "POST", body: { keepId, mergeId } }),
  gameCoinSummary: () => request("adminSummary", { base: "gameCoin/" }),
  coinSellers: () => request("admin/sellers", { base: "coinBank/" }),
  coinSellerCreate: (body) => request("admin/sellers", { method: "POST", body, base: "coinBank/" }),
  coinSellerUpdate: (id, body) => request(`admin/sellers/${id}`, { method: "PATCH", body, base: "coinBank/" }),
  coinSellerBalance: (id, body) => request(`admin/sellers/${id}/balance`, { method: "POST", body, base: "coinBank/" }),
  coinTxs: (o) => request(`admin/txs?${qs(o)}`, { base: "coinBank/" }),
  pkTournament: () => request("pkTournament"),
  pkTournamentSave: (body) => request("pkTournament", { method: "POST", body }),
  webGet: () => request("admin", { base: "web/" }),
  webSaveSite: (body) => request("admin/site", { method: "POST", body, base: "web/" }),
  webSaveStripe: (body) => request("admin/stripe", { method: "POST", body, base: "web/" }),
  webOrders: (o) => request(`admin/orders?${qs(o)}`, { base: "web/" }),
  salaryPolicy: () => request("admin/policy", { base: "salary/" }),
  salarySavePolicy: (body) => request("admin/policy", { method: "POST", body, base: "salary/" }),
  salaryMonths: (o) => request(`admin/months?${qs(o)}`, { base: "salary/" }),
  // yayinci odeme hesaplari (IBAN/Papara/USDT) — dogrulama
  payoutAccounts: (o) => request(`admin?${qs(o)}`, { base: "payout/" }),
  payoutAction: (id, body) => request(`admin/${id}`, { method: "PATCH", body, base: "payout/" }),
  // menu isareti: bekleyen hesap + cekim sayilari
  payoutCounts: () => request("admin/counts", { base: "payout/" }),
  // cekim talepleri
  redeemList: (o) => request(`?${qs(o)}`, { base: "redeem/" }), // type: pending|solved|decline
  redeemAction: (id, type) => request(`${id}?type=${type}`, { method: "PATCH", base: "redeem/" }), // accept|decline

  autoGreet: (o) => request(`admin/autoGreet?${qs(o)}`, { base: "chat/" }),
  autoGreetSet: (body) => request("admin/autoGreet", { method: "POST", body, base: "chat/" }),
  ledger: (o) => request(`admin/ledger?${qs(o)}`, { base: "salary/" }),
  giftFlow: (o) => request(`admin/giftflow?${qs(o)}`, { base: "salary/" }),
  ledgerPerson: (id) => request(`admin/person?${qs({ id })}`, { base: "salary/" }),
  ledgerPay: (body) => request("admin/pay", { method: "POST", body, base: "salary/" }),
  salaryWithdraws: (o) => request(`admin/withdraws?${qs(o)}`, { base: "salary/" }),
  salaryWithdrawAction: (id, body) => request(`admin/withdraws/${id}`, { method: "POST", body, base: "salary/" }),
  voiceRooms: (o) => request(`voiceRooms?${qs(o)}`),
  officialRooms: () => request("officialRooms"),
  createOfficialRoom: (body) => request("officialRooms", { method: "POST", body }),
  updateOfficialRoom: (id, body) => request(`officialRooms/${id}`, { method: "POST", body }),
  officialRoomStaff: (id, body) => request(`officialRooms/${id}/staff`, { method: "POST", body }),
  officialRoomDeny: (id, body) => request(`officialRooms/${id}/deny`, { method: "POST", body }),
  micTrack: (o) => request(`micTrack?${qs(o)}`),
  voiceRoom: (id) => request(`voiceRooms/${id}`),
  voiceRoomAction: (id, body) => request(`voiceRooms/${id}/action`, { method: "POST", body }),
  games: () => request("games"),
  leadercSync: () => request("games/leadercSync", { method: "POST" }),
  saveGame: (body) => request("games", { method: "POST", body }),
  deleteGame: (key) => request(`games/${key}`, { method: "DELETE" }),
  gameImage: (key, form) => request(`games/${key}/image`, { method: "POST", form }),
  pk: (o) => request(`pk?${qs(o)}`),
  endPk: (id, reason) => request(`pk/${id}/end`, { method: "POST", body: { reason } }),
  giftLogs: (o) => request(`giftLogs?${qs(o)}`),
  purchases: (o) => request(`purchases?${qs(o)}`),
  luckyBags: (o) => request(`luckyBags?${qs(o)}`),
  store: () => request("store"),
  saveStore: (id, form) => request(id ? `store/${id}` : "store", { method: "POST", form }),
  disableStore: (id) => request(`store/${id}`, { method: "DELETE" }),
  grantStore: (body) => request("store/grant", { method: "POST", body }),
  families: (o) => request(`families?${qs(o)}`),
  familyAction: (id, body) => request(`families/${id}/action`, { method: "POST", body }),
  marriages: (o) => request(`marriages?${qs(o)}`),
  endMarriage: (id, reason) => request(`marriages/${id}/end`, { method: "POST", body: { reason } }),
  rings: () => request("rings"),
  saveRing: (id, form) => request(id ? `rings/${id}` : "rings", { method: "POST", form }),
  blocks: (o) => request(`blocks?${qs(o)}`),
  underage: () => request("underage"),
  userSocial: (id) => request(`userSocial/${id}`),
  user360: (id) => request(`user360/${id}`),
  userDelete: (id, confirm) => request(`userDelete/${id}`, { method: "POST", body: { confirm } }),
  vipRevoke: (id) => request(`vipRevoke/${id}`, { method: "POST", body: {} }),
  vipList: () => request("vipList"),
  vipRevokeAll: (id) => request("vipRevokeAll", { method: "POST", body: id ? { id } : {} }),
  supportThreads: (o) => request(`admin/support?${qs(o)}`, { base: "inbox/" }),
  supportThread: (id) => request(`admin/support/${id}`, { base: "inbox/" }),
  supportReply: (id, text) => request(`admin/support/${id}/reply`, { method: "POST", body: { text }, base: "inbox/" }),
  supportStatus: (id, status) => request(`admin/support/${id}/status`, { method: "POST", body: { status }, base: "inbox/" }),
  activities: () => request("admin/activities", { base: "inbox/" }),
  saveActivity: (id, form) => request(id ? `admin/activities/${id}` : "admin/activities", { method: "POST", form, base: "inbox/" }),
  deleteActivity: (id) => request(`admin/activities/${id}`, { method: "DELETE", base: "inbox/" }),
  systemMessages: () => request("admin/system", { base: "inbox/" }),
  sendSystem: (form) => request("admin/system", { method: "POST", form, base: "inbox/" }),
  deleteSystem: (id) => request(`admin/system/${id}`, { method: "DELETE", base: "inbox/" }),
  friendStats: () => request("admin/friends", { base: "inbox/" }),
  agencies: (o) => request(`admin/list?${qs(o)}`, { base: "agency/" }),
  agency: (id) => request(`admin/${id}`, { base: "agency/" }),
  agencyManagers: () => request("admin/managerList", { base: "agency/" }),
  agencyAction: (id, body) => request(`admin/${id}/action`, { method: "POST", body, base: "agency/" }),
  agencyBan: (body) => request("admin/ban", { method: "POST", body, base: "agency/" }),
  staffRanks: () => request("admin/staffRanks", { base: "user/" }),
  setStaffRank: (body) => request("admin/staffRank", { method: "POST", body, base: "user/" }),
  setStaffManager: (body) => request("admin/staffManager", { method: "POST", body, base: "user/" }),
  agencyPayouts: (o) => request(`admin-payouts?${qs(o)}`, { base: "agency/" }),
  agencyPayoutAction: (id, body) => request(`admin-payouts/${id}`, { method: "POST", body, base: "agency/" }),
  guardians: () => request("adminList", { base: "guardian/" }),
  fanClubs: (o) => request(`adminList?${qs(o)}`, { base: "fan/" }),
  cardSummary: () => request("adminSummary", { base: "card/" }),
  invites: (o) => request(`adminSummary?${qs(o)}`, { base: "invite/" }),

  // cihaz / IP yasagi
  bans: (o) => request(`list?${qs(o)}`, { base: "ban/" }),
  banAdd: (body) => request("add", { method: "POST", body, base: "ban/" }),
  banUser: (body) => request("banUser", { method: "POST", body, base: "ban/" }),
  banRemove: (banId) => request(`remove?banId=${banId}`, { method: "DELETE", base: "ban/" }),
  banUserInfo: (userId) => request(`userInfo?userId=${userId}`, { base: "ban/" }),
  bdList: () => request("bd/admin/list", { base: "agency/" }),
  bdCreate: (body) => request("bd/admin/create", { method: "POST", body, base: "agency/" }),
  bdUpdate: (body) => request("bd/admin/update", { method: "POST", body, base: "agency/" }),
  bdDelete: (body) => request("bd/admin/delete", { method: "POST", body, base: "agency/" }),
  bdAssign: (body) => request("bd/admin/assign", { method: "POST", body, base: "agency/" }),
  bdPayouts: (state) => request(`bd/admin/payouts${state ? `?state=${state}` : ""}`, { base: "agency/" }),
  bdPayoutUpdate: (body) => request("bd/admin/payouts/update", { method: "POST", body, base: "agency/" }),
  agencyListAll: () => request("admin/list", { base: "agency/" }),
  agencyOfUser: (userId) => request(`admin/ofUser?userId=${userId}`, { base: "agency/" }),
  // acilis reklamlari
  splashList: () => request("admin", { base: "splash/" }),
  splashCreate: (form) => request("admin", { method: "POST", form, base: "splash/" }),
  splashUpdate: (id, form) => request(`admin?id=${id}`, { method: "PATCH", form, base: "splash/" }),
  splashDelete: (id) => request(`admin?id=${id}`, { method: "DELETE", base: "splash/" }),
  config: () => request("config"),
  saveConfig: (body) => request("config", { method: "POST", body }),
  gamesAppStats: (days) => request(`ludo/gamesAppStats?days=${days || 7}`, { base: "game/" }),
  gappPlayers: (q) => request(`gapp/admin/players?q=${encodeURIComponent(q || "")}`, { base: "game/" }),
  gappCoin: (userId, amount) => request("gapp/admin/coin", { method: "POST", body: { userId, amount }, base: "game/" }),
  gappBlock: (userId, block) => request("gapp/admin/block", { method: "POST", body: { userId, block }, base: "game/" }),
  gappSales: (days) => request(`gapp/admin/sales?days=${days || 30}`, { base: "game/" }),
  gappCasino: () => request("gapp/admin/casino", { base: "game/" }),
  gappRooms: () => request("gapp/rooms/admin", { base: "game/" }),
  gappAgora: () => request("gapp/admin/agora", { base: "game/" }),
  gappAgoraSave: (body) => request("gapp/admin/agora", { method: "POST", body, base: "game/" }),
  gappRoomClose: (roomId) => request("gapp/rooms/admin/close", { method: "POST", body: { roomId }, base: "game/" }),
  vipImage: (level, form) => request(`vipImage/${level}`, { method: "POST", form }),
  staffMe: () => request("me", { base: "staff/" }),
  staffLookup: (q) => request(`lookup?q=${encodeURIComponent(q)}`, { base: "staff/" }),
  staffSend: (body) => request("send", { method: "POST", body, base: "staff/" }),
  staffSent: () => request("sent", { base: "staff/" }),
  staffMembers: () => request("members", { base: "staff/" }),
  staffSaveMember: (id, body) => request(id ? `members/${id}` : "members", { method: "POST", body, base: "staff/" }),
  staffPackages: () => request("packages", { base: "staff/" }),
  staffSavePackage: (id, body) => request(id ? `packages/${id}` : "packages", { method: "POST", body, base: "staff/" }),
  levelFind: (q) => request(`levels?q=${encodeURIComponent(q)}`),
  levelSet: (id, body) => request(`levels/${id}`, { method: "POST", body }),
  moments: (o) => request(`admin/list?${qs(o)}`, { base: "moment/" }),
  momentAction: (id, action) => request(`admin/${id}/action`, { method: "POST", body: { action }, base: "moment/" }),
};

export default panelApi;
